import { useEffect, useState } from "react";

import useDataContext from "../providers/DataProvider/useDataContext";
import { AlertType } from "../types";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Whatsapp from "../components/Whatsapp/Whatsapp";
import ContactForm from "../components/ContactForm/ContactForm";
import Spinner from "../components/Spinner/Spinner";
import Alert from "../components/Alert/Alert";
import InstagramButton from "../components/InstagramButton/InstagramButton";

const ContactPage: React.FC = () => {
    const { data } = useDataContext();
    const [isSubmitProcessing, setIsSubmitProcessing] = useState(false);
    const [formAlert, setFormAlert] = useState<AlertType>({
        show: false,
        type: "undefined",
        info: {
            title: "",
            descriptions: []
        }
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth"});
    }, []);

    const handleOnSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitProcessing(true);
        try {
            const formElement = event.target as HTMLFormElement

            const formData = new FormData(formElement);
            const userName = formData.get("userName")?.toString() ?? "";
            const userEmail = formData.get("userEmail")?.toString() ?? "";
            const userMessage = formData.get("userMessage")?.toString() ?? "";

            const formSpree = new FormData();
            formSpree.append("Nombre", userName);
            formSpree.append("Correo", userEmail);
            formSpree.append("Mensaje", userMessage);

            const response = await fetch(formElement.action, {
                method: formElement.method,
                body: formSpree,
                headers: {
                    "Accept": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error();
            }

            setFormAlert({
                show: true,
                type: "success",
                info: {
                    title: data.pages.contactPage.successAlert.title,
                    descriptions: data.pages.contactPage.successAlert.descriptions
                }
            });
        }
        catch (err) {
            console.error(err);
            setFormAlert({
                show: true,
                type: "error",
                info: {
                    title: data.pages.contactPage.errorAlert.title,
                    descriptions: data.pages.contactPage.errorAlert.descriptions
                }
            });
        }
        finally {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setIsSubmitProcessing(false);
        }
    }

    return(
    <>
        <Header isHomePage={false}/>
        <main className="bg-forth-solid">
            <div className="container mx-auto flex flex-col items-center my-4 px-4 gap-8">
                <h1 className="special-title text-3xl font-bold lg:w-2/3 text-center">
                    { data.pages.contactPage.headingTitle }
                </h1>

                {
                    formAlert.show && (
                        <div className="lg:w-2/3">
                            <Alert alert={formAlert}/>
                        </div>
                    )
                }

                {
                    isSubmitProcessing ? (
                        <Spinner color="bg-first-solid" pxSize={20}/>
                    ) : (
                        <div className="h-full w-full lg:w-2/3">
                            <ContactForm onSubmit={handleOnSubmit}/>
                        </div>
                    )
                }
            </div>
        </main>
        <InstagramButton isHomePage={false}/>
        <Whatsapp isHomePage={false}/>
        <Footer isHomePage={false}/>
    </>
    )
}

export default ContactPage;
